import { useParams } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import useContentful from '../contexts/useContentful'

const ACTIVE_PAGE = {
  'housing': 0,
  'water': 1,
  'transportation': 2,
  'open-space-and-recreation': 3,
  
}

const COLORS = {
  0: 'hitYellow.main',
  1: 'hitBlue.main',
  2: 'hitPurple.main',
  3: 'hitGreen.main',
}

const SectionHeader = () => {
  const { pageID } = useParams()
  const {
    topicImages,
  } = useContentful()
  const activePage = ACTIVE_PAGE[pageID]

  return (
    <Stack
      display="grid"
      justifyContent="center"
      alignContent="flex-start"
      gap={2}
      gridTemplateColumns={{
        sm: 'repeat(2, 200px)',
        md: 'repeat(4, 200px)',
      }}
    >
      {topicImages?.map?.(({ fields }, idx) => {
        const isActive = idx === activePage
        
        return (
          <Stack
            display={{
              xs: isActive ? 'inline-grid' : 'none',
              sm: 'inline-grid',
            }}
            gridAutoFlow={{
              xs: 'column',
              sm: 'row',
            }}
            gap={1}
            justifyItems="center"
            alignItems={{
              xs: 'center',
              sm: 'flex-start',
            }}
            alignContent={{
              xs: 'center',
              sm: 'flex-start',
            }}
            textAlign={{
              sm: 'center',
            }}
            sx={{
              opacity: isActive ? 1 : .3,
            }}
          >
            <Box
              sx={{
                width: {
                  xs: 80,
                  sm: isActive ? 130 : undefined,
                },
                height: {
                  xs: 80,
                  sm: isActive ? 130 : undefined,
                }
              }}
            >
              <img 
                src={fields.file.url} 
                alt={fields.title}
              />
            </Box>
            <Typography
              variant={isActive ? 'sectionLabel' : 'h4'}
              color={{
                sm: COLORS[idx],
              }}
            >
              {fields.title}
            </Typography>
          </Stack>
        )  
      })}
    </Stack>
  )
}

export default SectionHeader